import React, { useEffect, useState } from 'react'
import { CardView, TableView } from '../../../_metronic/layout/components/RhEALComponent'

const Dashboard = () => {
    const [myLoading, setMyLoading] = useState<boolean>(false);
    const [dashBoardData, setDashBoardData] = useState<any>([])


    useEffect(() => {
        getDashBoardData()
    }, [])

    const getDashBoardData = () => {

        setMyLoading(true);

        const getMRObj = {
            method: "get_dashboard_zone",
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}get_dashboard_zone`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setDashBoardData(response?.data);
                        setMyLoading(false);                        
                    } else {
                        setMyLoading(false);
                    }
                });
            })
            .catch(() => {
                setMyLoading(false);
            });
    };


    return (
        <>
            <div className='row g-5'>
                <div className='col-6'>
                    <CardView zoneData={dashBoardData?.week} mrData={dashBoardData?.week_mr} title={'Performance (This Week)'} titleColor='#5B5B5B' /></div>
                <div className='col-6'>
                    <CardView zoneData={dashBoardData?.month} mrData={dashBoardData?.month_mr} title={'Performance (This Month)'} titleColor='#5B5B5B' /></div>
                <div className='col-6'>
                    <TableView data={dashBoardData?.top_mr_week} loading={myLoading} tableHeading={'Overall MR Performance (This Week)'} th1={'Name'} th2={'Zone'} th3={'Submission Count'} /></div>
                <div className='col-6'>
                    <TableView data={dashBoardData?.top_mr_month} loading={myLoading} tableHeading={'Overall MR Performance (This Month)'} th1={'Name'} th2={'Zone'} th3={'Submission Count'} /></div>
                <div className='col-6'>
                    <TableView data={dashBoardData?.top_zone_week} loading={myLoading} tableHeading={'Zone wise Performance (This Week)'} th2={'Zone'} th3={'Submission Count'} /></div>
                <div className='col-6'>
                    <TableView data={dashBoardData?.top_zone_month} loading={myLoading} tableHeading={'Zone wise Performance (This Month)'} th2={'Zone'} th3={'Submission Count'} /></div>
            </div>
        </>
    )
}

export default Dashboard